import { BACKEND_CLIENT_VERSION, REDUX_MEMBER_LIST_COLUMNS } from 'common/constants';

export const initState = {
    backendClientVersion: '',
    memberListVisibleColumns: {
        kyc_status: true,
        joined_date: true,
        first_deposit_date: true,
        last_deposit_date: true,
        ip_address: true,
        phone_number: true,
        whatsapp_number: true,
        email: true,
        member_bank_account_name: true,
        deposit_count: true,
        credit: true,
        referrer: true,
        downline: true,
        referral_code_enable: true,
        register_source: true,
    }
};

const globalReducer = (state = initState, action) => {
    switch (action.type) {
        case BACKEND_CLIENT_VERSION:
            return {
                ...state,
                backendClientVersion: action.payload
            };
        case REDUX_MEMBER_LIST_COLUMNS:
            return {
                ...state,
                memberListVisibleColumns: action.payload
            };
        default:
            return state;
    }
};

export default globalReducer;
